import React, { FC } from 'react'
import styled from 'styled-components'
import { animatedLoadingEffect } from 'uiComponents/constants/animations'
import {
  backgroundColor,
  complementaryColor,
} from 'uiComponents/constants/colors'

const FallbackWrapper = styled.section`
  cursor: default;
  display: block;
  overflow: hidden;
  position: relative;
  z-index: 0;
  background: ${complementaryColor};
`

const FallbackImage = styled.div`
  position: relative;
  width: 100%;
  border-radius: 2px;
  background-color: ${backgroundColor};
  height: 0;
  padding-top: 133%;
  overflow: hidden;
  ${animatedLoadingEffect};
`

export const FallbackSkeleton: FC = () => {
  return (
    <FallbackWrapper>
      <FallbackImage />
    </FallbackWrapper>
  )
}
